import * as React from 'react';
import { useEffect, useState } from "react";

import axios from 'axios';
import moment from "moment";

import ListItemAvatar from '@mui/material/ListItemAvatar';
import Avatar from '@mui/material/Avatar';
import Backdrop from '@mui/material/Backdrop';

import {
    Box,
    Button,
    CssBaseline,
    Divider,
    Drawer,
    IconButton,
    List,
    ListItem,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    Step,
    StepButton,
    Stepper,
    styled,
    TextField,
    Toolbar,
    Typography,
    useTheme,
    Paper,
    Alert,
    Modal,
    Fade,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
} from "@mui/material";

import CircularProgress from '@mui/material/CircularProgress';
import { Leaderboard } from "@mui/icons-material";
import { AppLoader } from "./../components/AppLoader.tsx";
import "../styles/pages/clients-roi-calculation-list.scss";

const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',   
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

export const ClientsROICalculationList = ({ onItemEditClick }) => {

    const [isLoading, setIsLoading] = useState(true);
    const [calculationsList, setCalculationsList] = useState([]);
    const [refreshList, setRefreshList] = useState(false);
    const [openErrorModal, setOpenErrorModal] = useState(false);
    const handleClose = () => setOpenErrorModal(false);

    const [showConfirmDelete, setShowConfirmDelete] = useState(false);
    const [deleteFileInfo, setDeleteFileInfo] = useState(undefined);

    const handleOkDelete = () => handleDeleteRoiCalculation(deleteFileInfo);

    const handleCancelDelete = () => {
        setDeleteFileInfo(undefined);
        setShowConfirmDelete(false);
    }    

    const handleDeleteButtonClick = (fileInfo) => {
        setDeleteFileInfo(fileInfo);
        setShowConfirmDelete(true);
    }       

    useEffect(() => {
        axios.get("api/Storage/Get")
            .then((response) => {
                console.log(response);

                setCalculationsList(response.data);
                setIsLoading(false);
            })
            .catch((err) => {
                setIsLoading(false);
                const errorMessage = typeof err.response.data === 'string' ? err.response.data : err.response.data.title;
                console.log(errorMessage);
            });
    }, [refreshList]);


    const handleGenerateRoiPdf = (fileInfo) => {
        setOpenErrorModal(false);
        axios({
            method: 'POST',
            data: fileInfo.fileName,
            url: "api/Document/GernerateRoiPdf",
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                /*"Access-Control-Allow-Origin": "*",*/
            },
            responseType: 'arraybuffer',
        })
            .then((res) => {
                console.log(res);

                let blob = new Blob([res.data], { type: 'application/pdf' });
                downloadFile(blob, "PAR Excellence Automated ROI.pdf");
            })      
            .catch((err) => {                
                setIsLoading(false);
                if (err.response.status == 500) {
                    setOpenErrorModal(true);
                }
                
                const errorMessage = typeof err.response.data === 'string' ? err.response.data : err.response.data.title;
                console.log(errorMessage);
            });
    };

    const handleDeleteRoiCalculation = (fileInfo) => {
        
        let url = "api/Storage/Delete";

        axios({
            method: 'delete',
            url: `${url}`,
            data: fileInfo.fileName,
            withCredentials: true,
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                /*"Access-Control-Allow-Origin": "*",*/
            },
        })
            .then((res) => {
                console.log(res);
                setDeleteFileInfo(undefined);
                setShowConfirmDelete(false);
                setRefreshList(!refreshList);
            })
            .catch(err => console.log('Login: ', err));       
    };

    const downloadFile = (blob, fileName) => {
        const link = document.createElement('a');
        // create a blobURI pointing to our Blob
        link.href = URL.createObjectURL(blob);
        link.download = fileName;
        // some browser needs the anchor to be in the doc
        document.body.append(link);
        link.click();
        link.remove();
        // in case the Blob uses a lot of memory
        setTimeout(() => URL.revokeObjectURL(link.href), 7000);
    };

    const getContent = () => {
        if (isLoading) {
            return (
                <>
                    <div className="container" id="roi-calculation-list">
                        <div className="content" style={{ minWidth: '690px', minHeight:'85vh' }}>
                       
                                <Box sx={{ flexGrow: 1 }}
                                    display="flex"
                                    justifyContent="center"
                                    alignItems="center"
                                    minHeight="80vh"
                                >
                                    <AppLoader />
                                </Box>
                       
                    </div>
                </div>
        </>
                           
                );
            
        }
        if (calculationsList.length == 0) {
           return <>
               <div className="container" id="roi-calculation-list">
                   <div className="content" style={{ minWidth: '690px', height: '80vh'}}>                      

                        <div className="MuiBox-root css-0" style={{ width: "100%" }}>
                            <div className="MuiBox-root css-24dupo">
                                <div className="MuiBox-root css-79elbk">{"No saved ROIs yet."}
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </>;
        }
        let generatePdfError;
        //if (generatePdfErrorMessage.length > 0) {
        //    generatePdfError = 
        //}
        let items;
        if (calculationsList && calculationsList.length > 0) {
           
            items = calculationsList.map((item, index) => {
                return <>
                    <ListItem key={index} alignItems="flex-start">
                    <>
                        <ListItemAvatar>
                            <ListItemIcon
                                sx={{ color: "red" }}>
                                <Leaderboard />
                            </ListItemIcon>
                        </ListItemAvatar>
                        <ListItemText
                            primary={

                                <>
                                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                        <Typography
                                            sx={{ display: 'inline' }}
                                            component="span"
                                            variant="body5"
                                            color="text.primary"                                            
                                            className="client-name"
                                        >
                                            {item.clientName}
                                            
                                        </Typography>
                                        <Typography
                                            sx={{ display: 'inline' }}
                                            component="span"
                                            variant="body2"
                                            color="text.primary"
                                        >
                                            <Typography sx={{ display: 'inline' }} variant="caption" display="block" mr={1} gutterBottom>
                                                Created On:
                                            </Typography>
                                            {moment(item.createdOn).format("llll")}
                                        </Typography>
                                    </Box>

                                </>

                            }
                            secondary={
                                <>
                                    <Box
                                        sx={{
                                            height: "50px",
                                            display: "flex",
                                            flexDirection: "row",
                                            pt: 2,
                                            justifyContent: "flex-end"
                                        }}
                                    >

                                        <Button variant="outlined" size="small"
                                            style={{ margin: "0 15px 0 0" }}
                                            onClick={() => onItemEditClick({fileName: item.name})}
                                        >
                                            Edit
                                        </Button>
                                        <Button variant="outlined" size="small"
                                            style={{ margin: "0 15px 0 0" }}
                                            onClick={() => handleGenerateRoiPdf({ fileName: item.name })}
                                        >
                                            Generate PDF
                                        </Button>
                                        <Button variant="outlined" size="small" sx={{ color: 'red' }}
                                            onClick={() => handleDeleteButtonClick({ fileName: item.name })}
                                        >
                                           Delete
                                        </Button>
                                    </Box>
                                </>
                            }

                        />
                        </>
                    </ListItem>
                    <Divider variant="inset" component="li" style={{ marginLeft: "0" }} />
                </>
            });
        }


        return (
            <>
                <div className="container" id="roi-calculation-list">
                    <div className="content" style={{ display: "block", minHeight: '80vh' }}>
                        <Box
                            style={{ marginBottom: "10px", maxWidth: "630px" }}
                        >
                            {generatePdfError}
                        </Box>
                        <Box
                            style={{ maxHeight: '75vh', width: "100%", overflow: 'auto' }}
                        >
                        <List sx={{ width: '100%', minHeight: '100%', bgcolor: 'background.paper' }}>
                            {items}
                            </List>
                        </Box>
                        <Modal
                            aria-labelledby="transition-modal-title"
                            aria-describedby="transition-modal-description"
                            open={openErrorModal}
                            onClose={handleClose}
                            closeAfterTransition
                            slots={{ backdrop: Backdrop }}
                            slotProps={{
                                backdrop: {
                                    timeout: 500,
                                },
                            }}
                        >
                            <Fade in={openErrorModal}>
                                <Box sx={style}>
                                    <Alert severity="error">{`We can't generate a PDF file for the requested ROI calculation. Please complete all the ROI calculation steps, and try again.`}</Alert>                                  
                                </Box>
                            </Fade>
                        </Modal>
                    </div>
                    {showConfirmDelete  && <Dialog
                        open={showConfirmDelete}
                        onClose={handleCancelDelete}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                    >   
                        <DialogTitle id="alert-dialog-title">
                            <Alert severity="warning">
                                Confirm Delete
                            </Alert>
                        </DialogTitle>
                        <DialogContent sx={{ pt: 0, pb: 0 }} >
                            <DialogContentText id="alert-dialog-description">
                                <Box sx={{ mt: 0, mb: 0, width: '100%', display: 'flex', justifyContent: 'space-between' }}>
                                    Are you sure you want to delete this ROI Calculation?
                                </Box>
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Box sx={{ mt: 0, width: '100%', display: 'flex', justifyContent: 'space-between' }}>                              
                                <Button onClick={handleOkDelete} color="error">Delete</Button>
                                <Button onClick={handleCancelDelete}>Cancel</Button>
                            </Box>
                        </DialogActions>
                    </Dialog>}
                </div>
            </>
        );
    }

    return (
       
                        getContent()
                   
    );
};

